// LifePolicyEntry related endpoints
export const LifePolicyEntryEndpoints = (builder) => ({
  // LifePolicyEntry CRUD operations
  // getLifePolicyEntrys: builder.query({
  //   query: (payload) => ({
  //     url: '//life-Insurance/LifePolicyEntry-list',
  //     method: 'POST',
  //     body: payload,
  //   }),
  //   providesTags: ['LifePolicyEntry'],
  // }),
  getLifePolicyEntry: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
        // collect any additional known params (optional)
        sortField,
        sortOrder,
        columnName,
        value,
        ...rest
      } = args;

      // Start with the common params
      const params = {
        pageNumber,
        pageSize,
      };

      // Helper to add only defined values
      const addIfDefined = (key, val) => {
        if (val !== null && val !== undefined) params[key] = val;
      };

      addIfDefined('searchTerm', searchTerm);
      addIfDefined('searchValue', searchValue);

      // Forward common UI params used by the component so backend can use them
      addIfDefined('sortField', sortField);
      addIfDefined('sortOrder', sortOrder);
      addIfDefined('columnName', columnName);
      addIfDefined('value', value);

      // Also forward any other extra primitive params passed in
      Object.keys(rest).forEach((k) => {
        const v = rest[k];
        if (v !== null && v !== undefined && (typeof v !== 'object' || Array.isArray(v))) {
          params[k] = v;
        }
        // If v is an object, skip to avoid '[object Object]' serialization
      });

      return {
        url: '/life-Insurance/get-life-policy',
        method: 'GET',
        params,
      };
    },
    providesTags: ['LifePolicyEntry'],
  }),

  getLifePolicyEntryById: builder.query({
    query: (id) => ({
      url: `/life-Insurance/get-life-policy/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'LifePolicyEntry', id }],
  }),

  saveLifePolicyEntry: builder.mutation({
    query: (data) => ({
      url: '/life-Insurance/save-lifePolicyEntry',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['LifePolicyEntry'],
  }),

  updateLifePolicyEntry: builder.mutation({
    query: ({ data }) => ({
      url: `/life-Insurance/save-lifePolicyEntry`,
      method: 'POST',
      body: data,
    }),
     invalidatesTags: ['LifePolicyEntry'],
  }),

  deleteLifePolicyEntry: builder.mutation({
    query: (id) => ({
      url: `/life-Insurance/delete-life-policy/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['LifePolicyEntry'],
  }),

  bulkDeleteLifePolicyEntry: builder.mutation({
    query: (body) => ({
      url: '/life-Insurance/bulk-delete-life-policy',
      method: 'DELETE',
      body,
    }),
    invalidatesTags: ['LifePolicyEntry'],
  }),

  checkPolicyExists: builder.query({
    query: (args) => {
      const { policyNumber } = args;
      return {
        url: '/life-Insurance/check-policy-exists',
        method: 'GET',
        params: { policyNumber },
      };
    },
    // No tags needed as this is a validation check
  }),

  calculateBasicPremium: builder.mutation({
    query: (data) => ({
      url: '/life-Insurance/calculate-basic-premium',
      method: 'POST',
      body: data,
    }),
  }),

  getValidTerms: builder.mutation({
    query: (data) => ({
      url: '/life-Insurance/get-valid-terms',
      method: 'POST',
      body: data,
    }),
  }),
});
